function getFileOverview (fileId) {
  if (!fileId) return
  if (!this.fileOverviews) return
  if (!this.fileOverviews[fileId]) console.warn(`fileOverview doesn't exist for ${fileId}`)
  return this.fileOverviews[fileId]
}

export default getFileOverview